<template>
    <div class="mb-3">
        <div class="text-muted small mb-2">Zones de corridoring</div>
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" :id="switchId" :checked="modelValue"
                @change="$emit('update:modelValue', $event.target.checked)" />
            <label class="form-check-label" :for="switchId">
                Afficher zones 200 m
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PanelCorridoringRadiusSection',
    props: {
        /** v-model */
        modelValue: { type: Boolean, default: false },
        /** id du switch (optionnel, pour éviter les collisions si plusieurs panels) */
        id: { type: String, default: 'toggle-corridoring-circles' },
    },
    emits: ['update:modelValue'],
    computed: {
        switchId() {
            return this.id || 'toggle-corridoring-circles';
        }
    }
}
</script>

<style scoped>
/* Pas de styles particuliers requis : on s’appuie sur Bootstrap */
</style>
